document.addEventListener("DOMContentLoaded", function () {
  const totalAreaRadio = document.getElementById("total-area");
  const widthLengthRadio = document.getElementById("Width-Length");

  const areaInputContainer = document.querySelector(".input-container-area");
  const lengthWidthInputsContainer = document.querySelector(".length-width-inputs");

  function toggleInputFields() {
    if (totalAreaRadio.checked) {
      areaInputContainer.style.display = "block";
      lengthWidthInputsContainer.style.display = "none";
    } else {
      areaInputContainer.style.display = "none";
      lengthWidthInputsContainer.style.display = "flex";
    }
  }

  toggleInputFields();

  totalAreaRadio.addEventListener("change", toggleInputFields);
  widthLengthRadio.addEventListener("change", toggleInputFields);

  let currentUnit = "meters";

  function convertToMeters(value, unit, isArea = false) {
    if (isNaN(value)) return 0;
    const conversions = {
      centimeters: isArea ? value / 1000 : value / 100,
      feet: isArea ? value / 10.764 : value / 3.281,
    };
    return conversions[unit] !== undefined ? conversions[unit] : value;
  }


  function updateLabels() {
    const unitLabels = {
      meters: { width: "(m)", length: "(m)", area: "(m²)" },
      centimeters: { width: "(cm)", length: "(cm)", area: "(cm²)" },
      feet: { width: "(ft)", length: "(ft)", area: "(ft²)" },
    };
    const labels = unitLabels[currentUnit];
    document.querySelector("label[for='calculator-width']").innerHTML = labels.width;
    document.querySelector("label[for='calculator-length']").innerHTML = labels.length;
    document.querySelector("label[for='calculator-area']").innerHTML = labels.area;
  }

  window.updateCustomPriceDisplay = function (totalPrice) {
    if (typeof totalPrice !== "number" || isNaN(totalPrice)) return;
    const priceDisplay = document.getElementById("total-price-display");
    const btnPriceDisplay = document.getElementById("button-dynamic-pricing");
    const vatCurrent = sessionStorage.getItem("vatToggle");
    const includeVAT = vatCurrent === "true";
    const displayPrice = includeVAT ? totalPrice : totalPrice / 1.2;
    const vatMessage = includeVAT ? ' inc VAT' : ' ex VAT';
    const vatMessageHolder = document.querySelector('.vat-message');
    if (priceDisplay) {
      priceDisplay.innerHTML = `£${displayPrice.toFixed(2)}` + `<span class="vat-message">${vatMessage}</span>`;
    }
    if (btnPriceDisplay) {
      btnPriceDisplay.innerHTML = `£${displayPrice.toFixed(2)}` + vatMessage;
    }
  };

  function calculateQuantityLengthWidth() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    const addWastage = document.getElementById("add-wastage").checked;

    if (isNaN(width) || isNaN(length)) {
      document.getElementById("qty-required").innerHTML = "Qty Required: 0";
      document.getElementById("area-required-value").innerHTML = "0";
      return;
    }

    const coverage = parseFloat(document.querySelector(".calculator-div").getAttribute("data-metafield-coverage"));
    let convertedWidth = convertToMeters(width, currentUnit);
    let convertedLength = convertToMeters(length, currentUnit);
    let output = convertedWidth * convertedLength;
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    document.getElementById("qty-required").innerHTML = "Qty Required: " + output + " packs";
    document.getElementById("area-required-value").innerHTML = areaOutput;

    const calculatorDiv = document.querySelector(".calculator-div");
    if (calculatorDiv) {
      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
      quantityPicker.value = output;
      quantityPicker.setAttribute("value", output);
    }

    const perPackPrice = parseFloat(document.querySelector('.calculator-div').getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function calculateQuantityArea() {
    const area = parseFloat(document.getElementById("calculator-area").value);
    const addWastage = document.getElementById("add-wastage").checked;

    if (isNaN(area)) {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
      return;
    }

    const coverage = parseFloat(document.querySelector(".calculator-div").getAttribute("data-metafield-coverage"));
    let output = convertToMeters(area, currentUnit, true);
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    document.getElementById("qty-required").innerHTML = "Total Packs: " + output;
    document.getElementById("area-required-value").innerHTML = areaOutput;

    const calculatorDiv = document.querySelector(".calculator-div");
    if (calculatorDiv) {
      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
      quantityPicker.value = output;
      quantityPicker.setAttribute("value", output);
    }

    const perPackPrice = parseFloat(document.querySelector('.calculator-div').getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    const addProperty = document.getElementById("totalPacksTally");
    addProperty.setAttribute('value', output);

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function wastage() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    const area = parseFloat(document.getElementById("calculator-area").value);

    if (!isNaN(width) || !isNaN(length)) {
      document.getElementById("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else if (!isNaN(area)) {
      document.getElementById("calculator-width").value = "";
      document.getElementById("calculator-length").value = "";
      calculateQuantityArea();
    } else {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
    }
  }

  function wastageLengthWidth() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    if (!isNaN(width) || !isNaN(length)) {
      document.getElementById("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
    }
  }

  function wastageArea() {
    const area = parseFloat(document.getElementById("calculator-area").value);
    if (!isNaN(area)) {
      document.getElementById("calculator-width").value = "";
      document.getElementById("calculator-length").value = "";
      calculateQuantityArea();
    }
  }

  const unitRadios = document.querySelectorAll('input[name="measurement-unit"]');

  function updateUnit() {
    const selectedUnit = document.querySelector("input[name='measurement-unit']:checked");
    if (selectedUnit) {
      currentUnit = selectedUnit.value;
      updateLabels();
      wastage();
    }
  }

  unitRadios.forEach((radio) => {
    radio.addEventListener("change", updateUnit);
  });

  updateUnit();

  document.getElementById("calculator-width").addEventListener("input", wastageLengthWidth);
  document.getElementById("calculator-length").addEventListener("input", wastageLengthWidth);
  document.getElementById("calculator-area").addEventListener("input", wastageArea);
  document.getElementById("add-wastage").addEventListener("change", wastage);

  updateLabels();
});
